<script setup>
import { computed, inject } from 'vue';
import { buttonColors, fontStack, borderStyle } from '../canvasStyles';

const props = defineProps({ element: { type: Object, required: true } });
defineOptions({ inheritAttrs: false });

const ed = inject('emailEditor');
const theme = computed(() => ed.template.value?.theme || {});
const st = computed(() => props.element.style || {});
const JUSTIFY = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};
const look = computed(() => {
  const { bg, fg } = buttonColors(st.value, theme.value);
  const [pv, ph] = st.value.padding_inner || [14, 28];
  return {
    backgroundColor: bg,
    color: fg,
    fontFamily: fontStack(st.value.font_family, ed.doc.value, theme.value),
    fontSize: `${st.value.font_size}px`,
    fontWeight: st.value.font_weight,
    padding: `${pv}px ${ph}px`,
    borderRadius: `${st.value.radius}px`,
    width: st.value.full_width ? '100%' : undefined,
    ...borderStyle(st.value.border, theme.value),
  };
});
</script>

<template>
  <div class="flex" :class="JUSTIFY[st.align] || 'justify-center'">
    <span class="inline-block text-center leading-tight" :style="look">{{
      element.label
    }}</span>
  </div>
</template>
